import { create } from 'zustand';
import { assert } from '../../utils/assert';
// how long starting a recording may take before the UI calls it slow
const RECORDING_INITIALIZATION_DURATION_MS = 15000;
const useRecordingOutput = create(() => ({
    isAvailable: false,
    uploads: [],
}));
const reactiveOutput = {
    useIsAvailable: () => useRecordingOutput((state) => state.isAvailable),
    useActiveRecording: () => useRecordingOutput((state) => state.activeRecording),
    useInitializationDurationMs: () => RECORDING_INITIALIZATION_DURATION_MS,
    useRecordingsList: () => useRecordingOutput((state) => state.recordingsList),
    useUploads: () => useRecordingOutput((state) => state.uploads),
};
export class RecordingServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setIsAvailable(isAvailable) {
        useRecordingOutput.setState({ isAvailable });
    }
    setActiveRecording(activeRecording) {
        useRecordingOutput.setState({
            activeRecording,
        });
    }
    setActiveRecordingStatus(status, message) {
        useRecordingOutput.setState((current) => {
            return {
                ...current,
                activeRecording: {
                    ...current.activeRecording,
                    status,
                    message,
                },
            };
        });
    }
    setActiveRecordingInitializedAt(initializedAt) {
        useRecordingOutput.setState((current) => {
            assert(current.activeRecording, 'Recording is not active');
            return {
                ...current,
                activeRecording: {
                    ...current.activeRecording,
                    initializedAt,
                },
            };
        });
    }
    /** Adds the upload, or replaces what is known about it. */
    setUpload(upload) {
        useRecordingOutput.setState((current) => ({
            ...current,
            uploads: [
                ...current.uploads.filter((u) => u.recordingId !== upload.recordingId),
                upload,
            ],
        }));
    }
    removeUpload(recordingId) {
        useRecordingOutput.setState((current) => ({
            ...current,
            uploads: current.uploads.filter((u) => u.recordingId !== recordingId),
        }));
    }
    initRecordingsList() {
        useRecordingOutput.setState((current) => {
            return {
                ...current,
                recordingsList: {
                    status: 'loading',
                    recordings: [],
                    hasMore: false,
                },
            };
        });
    }
    clearRecordingsList() {
        useRecordingOutput.setState((current) => {
            return {
                ...current,
                recordingsList: undefined,
            };
        });
    }
    updateRecordingsListStatus(status) {
        useRecordingOutput.setState((current) => {
            assert(current.recordingsList, 'Recordings list was not initialized');
            return {
                ...current,
                recordingsList: {
                    ...current.recordingsList,
                    status,
                },
            };
        });
    }
    updateRecordingsListEntries(recordings) {
        useRecordingOutput.setState((current) => {
            assert(current.recordingsList, 'Recordings list was not initialized');
            return {
                ...current,
                recordingsList: {
                    ...current.recordingsList,
                    recordings: [
                        ...current.recordingsList.recordings,
                        ...recordings,
                    ],
                },
            };
        });
    }
    removeRecordingsListEntry(recordingId) {
        useRecordingOutput.setState((current) => {
            if (!current.recordingsList) {
                return current;
            }
            return {
                ...current,
                recordingsList: {
                    ...current.recordingsList,
                    recordings: current.recordingsList.recordings.filter((r) => r.recordingId !== recordingId),
                },
            };
        });
    }
    updateRecordingsListHasMore(hasMore) {
        useRecordingOutput.setState((current) => {
            assert(current.recordingsList, 'Recordings list was not initialized');
            return {
                ...current,
                recordingsList: {
                    ...current.recordingsList,
                    hasMore,
                },
            };
        });
    }
}
